module.exports = __webpack_public_path__ + "static/img/zhiwei.228944d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhiwei.png
// module id = 2aTi
// module chunks = 36